import React from "react";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import Footer from "@/components/Footer/Footer";
import { selectFocusMode } from "@/app/globalSlices/appStripSlice";

interface MainContentProps {
  children: ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  // A course or learning path is open: the player fills the scroll area
  // exactly, so the footer would only add a dead strip under it on phones.
  const focusMode = useSelector(selectFocusMode);

  return (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden bg-gray-50 dark:bg-slate-950">
      <main className="relative flex-1 overflow-y-auto" id="main-scroll-area">
        <div>{children}</div>
        {!focusMode && <Footer />}
      </main>
    </div>
  );
};

export default MainContent;
